import React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Grid,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Autocomplete,
  Rating,
  Divider,
  Toolbar,
  Tooltip,
  Badge,
  Popover,
  TablePagination,
} from "@mui/material";
import {
  Star,
  CardGiftcard,
  Warning,
  Refresh,
  CheckCircle,
  Copyright,
  Send,
  Info,
  Description,
  Edit,
  Chat,
  KeyboardArrowDown,
  Close,
  Business,
} from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import {
  ApiEditorClientEntities,
  ApiGenerateReportPdf,
  ApiGetClientEntities,
  ApiGetClientEntityByClientGroupId,
  ApiGetShopperPopUpDetails,
  ApiMasterRating,
} from "../../../apiService/Core/Apicall.tsx";
import emoji0 from "../../../assets/images/emoji0.svg";
import emoji1 from "../../../assets/images/emoji1.svg";
import emoji2 from "../../../assets/images/emoji2.svg";
import emoji3 from "../../../assets/images/emoji3.svg";
import emoji4 from "../../../assets/images/emoji4.svg";
import emoji5 from "../../../assets/images/emoji5.svg";
import PatchedReactQuill from "../ManageVenue/PatchedReactQuill.tsx";
import Dcrage from "../OrphanAllocation/Dcrage.tsx";
import { toast } from "react-toastify";
import { CustomDownloadPdf } from "../../../apiService/Core/CustomDownloadPdf.tsx";
import { useSelector } from "react-redux";
import { RootState } from "../../../global/config/store.ts";
import {
  ApiDeleteReport,
  ApiPostShopperFeedback,
  ApiReportList,
  ApiShopperFeedback,
  ApiUpdateReportStatus,
} from "../../../apiService/Core/CustomApiManageReports.tsx";
import { number } from "yup";

interface Business {
  label: string;
  value: string;
}

// Custom styled button with olive green background
const OliveButton = ({
  children,
  ...props
}: React.ComponentProps<typeof Button>) => (
  <Button
    {...props}
    sx={{
      backgroundColor: "#7a7d52",
      color: "white",
      "&:hover": {
        backgroundColor: "#5e6040",
      },
      textTransform: "none",
      ...props.sx,
    }}
    variant="contained"
  >
    {children}
  </Button>
);

// Action button component for the grid
const ActionButton = ({
  icon,
  label,
  onClick,
}: {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      p: 1,
      border: "1px solid #ccc",
      height: "100%",
      cursor: onClick ? "pointer" : "default",
    }}
    onClick={onClick}
  >
    <Box sx={{ mr: 1 }}>{icon}</Box>
    <Typography variant="body2">{label}</Typography>
  </Box>
);

const emojiMap: { [key: number]: string } = {
  1: emoji1,
  2: emoji2,
  3: emoji3,
  4: emoji4,
  5: emoji5,
};

// Emoji component based on rating
const RatingEmoji = ({ rating }: { rating: number }) => {
  const emojiSrc = emojiMap[rating] || emoji0; // Default to lowest rating emoji

  return (
    <img src={emojiSrc} alt={`Rating: ${rating}`} width={60} height={60} />
  );
};

export default function ManageReports() {
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const [shopperFeedback, setShopperFeedback] = useState<any>([]);
  const [displayStatus, setDisplayStatus] = useState(1);
  const [selectedRow, setSelectedRow] = useState<any>([]);
  const [bonusDialogOpen, setBonusDialogOpen] = useState(false);
  const [penaltyDialogOpen, setPenaltyDialogOpen] = useState(false);
  const [bonusAmount, setBonusAmount] = useState();
  const [bonusReason, setBonusReason] = useState();
  const [businesses, setBusinesses] = useState<Business[]>([]);
  const [penaltyAmount, setPenaltyAmount] = useState(0.0);
  const [penaltyReason, setPenaltyReason] = useState();
  const [editorSummeryDialogOpen, setEditorSummeryDialogOpen] = useState(false);
  const [editorSummery, setEditorSummery] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [masterRating, setmasterRating] = useState<any>([]);
  const [reportlist, setreportlist] = useState<any>([]);
  const [activepopup, setactivepopup] = useState<number>();
  const [datalength, setdatalength] = useState<any>(null);

  const [reportHeaderId, setreportHeaderId] = useState<number>();
  // const Clientlist = useSelector((state: RootState) => state.client.clientList);
  // const [selectedClient, setSelectedClient] = useState(Clientlist[2] || null);
  // const [ClientId, setClientId] = useState(Clientlist[2]?.clientGroupName);
  const Clientlist = useSelector((state: RootState) => state.client.clientList);
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const [ClientId, setClientId] = useState(null);
  const [clientEntityId, setclientEntityId] = useState<any>(null);
  const navigate = useNavigate();
  const userRole:any = localStorage.getItem("userRole");
  const userId:any = localStorage.getItem("userId");

  useEffect(() => {
    if (Clientlist.length > 2) {
      setSelectedClient(Clientlist[2]);
      setClientId(Clientlist[2].clientGroupName);
      handleGetReportList(1);
    }
  }, [Clientlist]);
  const [loanData, setLoanData] = useState();

  // Shopper Rating Dialog States
  const [ratingDialogOpen, setRatingDialogOpen] = useState(false);
  const [ratings, setRatings] = useState<any>();
  const [ratingComment, setRatingComment] = useState("Thanks for completing");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    console.log("ClientId", ClientId);
    handleGetClientList();
    handleGetReportList(displayStatus);
  }, [ClientId]);

  const handleGetClientList = async () => {
    const data = `?ClientGroupName=${ClientId}`;
    const data2 = `?editorId=${userId}&clientGroupName=${ClientId}`;
    
    if (!ClientId) return;
    try {
      const res: any = userRole == 3 ? await ApiEditorClientEntities(data2) : await ApiGetClientEntityByClientGroupId(data);

      const response = (res?.data || [])
        .filter((item) => item && item.entityName && item.clientEntityId) // Remove null/undefined or incomplete objects
        .map((item) => ({
          label: item.entityName,
          value: item.clientEntityId,
        }));

      console.log("Filtered data:", response);
      setclientEntityId(response[0])
      setBusinesses(response);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleHover = async (event, index, item?: any) => {
    setAnchorEl(event.currentTarget);
    try {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1; // Months are zero-based, so add 1
      const currentYear = currentDate.getFullYear();

      const data = `?userId=${item.userId}&currentMonth=${currentMonth}&currentYear=${currentYear}`;

      // Call API to get shopper details
      const response = await ApiGetShopperPopUpDetails(data);

      if (!response.status) {
        toast.error("Failed to load shopper details");
        return;
      }

      // Set shopper details from API response
      if (response.data) {
        setLoanData(response.data);
      }
    } catch (error) {
      //toast.error("Error loading shopper details");
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  // ------------------------------------------------------Shopper Bonus DialogBox  Handlers ---------------------------------

  const handleOpenBonusDialog = (reportHeaderId) => {
    setBonusDialogOpen(true);
    setactivepopup(reportHeaderId);
    getshopperfeedback(reportHeaderId);
  };

  const handleCloseBonusDialog = () => {
    setBonusDialogOpen(false);
  };

  // ------------------------------------------------------Shopper Penulty DialogBox  Handlers ---------------------------------

  const handleOpenPenaltyDialog = (reportHeaderId) => {
    setPenaltyDialogOpen(true);
    setactivepopup(reportHeaderId);
    getshopperfeedback(reportHeaderId);
  };

  const handleClosePenaltyDialog = () => {
    setPenaltyDialogOpen(false);
  };

  // ------------------------------------------------------Shopper Summary DialogBox  Handlers ---------------------------------

  const handleOpeneditorSummeryDialog = (reportHeaderId) => {
    setEditorSummeryDialogOpen(true);
    setactivepopup(reportHeaderId);

    getshopperfeedback(reportHeaderId);
  };

  const handleCloseEditorSummeryDialog = () => {
    setEditorSummeryDialogOpen(false);
  };
  // ------------------------------------------------------Shopper Bonus Handlers ---------------------------------

  const handleSaveBonus = async () => {
    const data = {
      reportHeaderId: activepopup,
      createdBy: Number(localStorage.getItem("createdBy")),
      bonus: {
        bonusAmount: bonusAmount,
        bonusReason: bonusReason,
      },
    };
    try {
      const response = await ApiPostShopperFeedback(data, ClientId);
      toast.success(response.message);
      handleGetReportList(displayStatus);
    } catch (error) {
      toast.error(error);
    }
    setBonusDialogOpen(false);
    // Reset form fields
    //setBonusAmount("");
    //setBonusReason("");
  };
  // ------------------------------------------------------ShopperPenulty Handlers ---------------------------------

  const handleSavePenalty = async () => {
    const data = {
      reportHeaderId: activepopup,
      createdBy: Number(localStorage.getItem("createdBy")),
      penalty: {
        penaltyAmount: penaltyAmount,
        penaltyReason: penaltyReason,
      },
    };
    try {
      const response = await ApiPostShopperFeedback(data, ClientId);
      toast.success(response.message);
      handleGetReportList(displayStatus);
    } catch (error) {
      toast.error(error);
    }
    setPenaltyDialogOpen(false);

    // Reset form fields
  };
  // ------------------------------------------------------Shopper Summary Handlers ---------------------------------

  const handleSaveEditorSummery = async () => {
    const data = {
      reportHeaderId: activepopup,
      editorSummary: editorSummery,
      createdBy: Number(localStorage.getItem("createdBy")),
    };
    console.log("Send SUmmary", data);
    try {
      const response = await ApiPostShopperFeedback(data, ClientId);
      toast.success(response.message);
    } catch (error) {
      toast.error(error);
    }
    setEditorSummeryDialogOpen(false);
  };

  // ------------------------------------------------------Shopper Rating Dialog Handlers ---------------------------------

  const handleOpenRatingDialog = async (reportHeaderId) => {
    await getshopperfeedback(reportHeaderId);
    setRatingDialogOpen(true);
    setactivepopup(reportHeaderId);
  };
  const handleCloseRatingDialog = () => {
    setRatingDialogOpen(false);
  };

  // -------------------------------------------------------------------Save Rating ---------------------------------
  const handleSaveRating = async () => {
    const ratingData = {
      reportHeaderId: activepopup,
      createdBy: Number(localStorage.getItem("createdBy")),
      shopperRating: ratings,
      commentForShopper: ratingComment,
    };
    console.log("Send Data", ratingData);
    try {
      const response = await ApiPostShopperFeedback(ratingData, ClientId);
      toast.success(response.message);
      handleGetReportList(displayStatus);
    } catch (error) {
      toast.error(error);
    }

    setRatingDialogOpen(false);
  };

  // -------------------------------------------------- Handle Rating Change -----------------------------------------
  const handleRatingChange = (category: number, value: number) => {
    setRatings((prevRatings) => {
      // Find the existing rating by ID
      const existingIndex = prevRatings.findIndex(
        (item) => item.overRatingId === category
      );

      if (existingIndex !== -1) {
        // Update the existing rating
        return prevRatings.map((item) =>
          item.overRatingId === category
            ? { ...item, overAllRatingScore: value }
            : item
        );
      } else {
        // Add a new rating entry
        return [
          ...prevRatings,
          { overRatingId: category, overAllRatingScore: value },
        ];
      }
    });

    console.log("Updated Ratings:", ratings); // May not reflect immediately due to React's async state updates
  };
  useEffect(() => {
    const masterrating = async () => {
      try {
        const response = await ApiMasterRating();
        setmasterRating(response.data);
      } catch (error) {
        toast.error(error);
      }
    };
    masterrating();
  }, []);

  // -------------------------------------------------Get ReportList ----------------------------------------------
  useEffect(() => {
    if (!selectedDate) return;

    handleGetReportList(displayStatus);
  }, [selectedDate, rowsPerPage, clientEntityId, page, rowsPerPage]);

  const handleGetReportList = async (number?: any) => {
    console.log("under FUnction",number)
    if (!selectedDate) return;
    if (ClientId && clientEntityId) {
      try {
        const response = await ApiReportList(
          page,
          rowsPerPage,
          selectedDate?.getMonth() + 1,
          selectedDate?.getFullYear(),
          number,
          ClientId,
          clientEntityId
        );

        if (response.status) {
          console.log("responseData", response.data);
          setdatalength(response.totalDataCount)
          setreportlist(response.data);
        }
      } catch (error) {
        alert(error)
      }
      finally {
        console.log("ReportList", reportlist)
      }
    }

  };

  // ------------------------------------------- Chnage Pagination -----------------------------------------------
  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // ------------------------------------------Get ShopperFeedback ----------------------------------
  const getshopperfeedback = async (reportHeaderId) => {
    const response = await ApiShopperFeedback(reportHeaderId, ClientId);
    console.log("CurruntRating", response.data);
    // setShopperFeedback(response.data)
    setRatings(
      response.data.ratings.map((rating) => ({
        overAllRatingScore: parseInt(rating.overAllRatingScore),
        overRatingId: rating.overRatingId.overAllRatingId,
      }))
    );
    setEditorSummery(response.data.reportHeader.editorComment);
    setBonusAmount(response.data.reportHeader.bonus);
    setBonusReason(response.data.reportHeader.bonusReason);
    setPenaltyAmount(response.data.reportHeader.penalty);
    setPenaltyReason(response.data.reportHeader.penaltyReason);
    setRatingComment(response.data.reportHeader.commentForShopper);
  };

  const handleDisplayChange = async (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const selectedValue = event.target.value as number;
    setDisplayStatus(selectedValue);
    if (ClientId && clientEntityId) {
      try {
        // Call your API here
        if (!selectedDate) return;
        const response = await ApiReportList(
          page,
          rowsPerPage,
          selectedDate?.getMonth() + 1,
          selectedDate?.getFullYear(),
          selectedValue,
          ClientId,
          clientEntityId
        );
        console.log(response.data);
        setdatalength(response.totalDataCount)
        setreportlist(response.data);
        console.log("Status updated successfully");
      } catch (error) {
        console.error("Error updating status:", error);
      }

    }

  };

  const handleEditScoreCard = (allocationId: any) => {
    navigate(`/createOrEditScoreCard/${allocationId}`, {
      state: { clientGroup: ClientId },
    });
    //window.open(`/createOrEditScoreCard/${allocationId}`, "_blank");
  };

  const handleApproved = async (reportHeaderId, Status) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to Approve this report?"
    );
    if (isConfirmed) {
      try {
        const data = {
          reportHeaderIds: reportHeaderId,
          status: Status,
        };
        // Call your API here
        const response = await ApiUpdateReportStatus(data, ClientId);
        toast.success("Status updated successfully");
        handleGetReportList(Number(displayStatus));
      } catch (error) {
        console.error("Error updating status:", error);
      }
    }
  };

  const handleReleased = async (reportHeaderId, Status) => {
    const isConfirmed = window.confirm(
      reportHeaderId > 0 ? "Are you sure you want to Release this report?" : "Are you sure you want to Release selected reports?"
    );
    if (isConfirmed) {
      try {
        const data = {
          reportHeaderIds: reportHeaderId > 0 ? reportHeaderId: selectedRow,
          status: Status,
        };
        console.log("Sed Data", data)
        // Call your API here
        const response = await ApiUpdateReportStatus(data, ClientId);
        toast.success("Status updated successfully");
        handleGetReportList(Number(displayStatus));
        console.log("display Stauts",displayStatus)
      } catch (error) {
        console.error("Error updating status:", error);
      }
      finally{
        setSelectedRow([])
      }
    }
  };

  const handleDownloadPdf = async (allocationId: any) => {
    try {
      await CustomDownloadPdf(allocationId, ClientId);
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error(error);
    }
  };

  const handleRollBack = async (reportHeaderId, Status) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to Uncofirmed this report?"
    );
    if (isConfirmed) {
      try {
        const data = {
          reportHeaderIds: reportHeaderId,
          status: Status,
        };
        // Call your API here
        const response = await ApiUpdateReportStatus(data, ClientId);
        toast.success("Status updated successfully");
        handleGetReportList(displayStatus);
      } catch (error) {
        console.error("Error updating status:", error);
      }
    }
  };
  const handleDelteReport = async () => {
    const isConfirmed = window.confirm(
      "Are you sure you want to Delete this report?"
    );
    if (isConfirmed) {
      try {
        const data = `?reportHeaderIds=[${selectedRow}]`
        // console.log("delet Report", data)
        // Call your API here
        const response = await ApiDeleteReport(data, ClientId);
        toast.success("Status updated successfully");
        handleGetReportList(1);
      } catch (error) {
        console.error("Error updating status:", error);
      }
    }
  };

  useEffect(() => {
    if (businesses.length > 0) {
      setclientEntityId(businesses[0]);
    }
  }, [businesses])


  const handleSelectRow = (index: number) => {
    setSelectedRow((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };

  return (
    <Box sx={{ maxWidth: "100%", overflow: "hidden" }}>
      {/* Header */}
      <Box sx={{ p: 3, textAlign: "center", mb: 2 }}>
        <Typography variant="h4" component="h1" fontWeight="bold">
          Manage Reports
        </Typography>
      </Box>

      {/* Controls */}
      <Box sx={{ display: "flex", justifyContent: "center", mb: 2, px: 2 }}>
        {/* <OliveButton>All Report Status</OliveButton> */}

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            views={["month", "year"]}
            label=""
            value={selectedDate}
            onChange={(newDate) => setSelectedDate(newDate)}
            format="MM/yyyy"
            sx={{
              width: "400px",
              "& .MuiOutlinedInput-root": {
                borderRadius: 1,
              },
            }}
          />
        </LocalizationProvider>

        {/* <OliveButton>DOWNLOAD AS XLS</OliveButton> */}
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          px: 2,
        }}
      >
        {/* Left: Autocomplete Field */}

        <Box sx={{ flex: 1, mr: 2 }}>
          <Autocomplete
            id="mm-autocomplete"
            options={Clientlist}
            value={selectedClient}
            getOptionLabel={(option) => option?.clientGroupName}
            isOptionEqualToValue={(option, value) =>
              option.clientGroupDBName === value.clientGroupDBName
            }
            onChange={(event, newValue: any) => {
              setSelectedClient(newValue);
              setClientId(newValue?.clientGroupName || null);
              // if (!newValue) {
              //   setClientEntityList(null);
              // }
            }}
            renderInput={(params) => (
              <TextField {...params} label="Select Client" />
            )}
          //sx={{ width: "20%" }}
          />
        </Box>
        <Box sx={{ flex: 1, mr: 2 }}>
          <Autocomplete
            options={businesses}
            value={clientEntityId}
            onChange={(event, newValue: any) => {
              setclientEntityId(newValue);
            }}
            getOptionLabel={(option) => option.label || ''}
            renderInput={(params) => (
              <TextField {...params} label="Select Business" />
            )}
          />
        </Box>

        {/* Right: Update Button */}
        <Box>
          <OliveButton>Update</OliveButton>
        </Box>
      </Box>

      {/* Display dropdown */}
      <Box
        sx={{
          p: 2,
          border: "1px solid #e0e0e0",
          borderRadius: 1,
          mx: 2,
          mb: 2,
        }}
      >
        <Typography variant="body2" sx={{ mb: 1 }}>
          Display...
        </Typography>
        <FormControl fullWidth>
          <Select
            value={displayStatus}
            onChange={(e: any) => handleDisplayChange(e)}
            displayEmpty
            sx={{ borderRadius: 1 }}
            IconComponent={KeyboardArrowDown}
          >
            <MenuItem value="1">
              Unconfirmed (not yet ready for approval)
            </MenuItem>
            <MenuItem value="2">Confirmed(Ready for your approval)</MenuItem>
            <MenuItem value="3">
              Approved(Already sent to venue administrator)
            </MenuItem>
            <MenuItem value="4">
              Released(Venue admin has release to venues)
            </MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* Release Selected button */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2, px: 2 }}>
        <OliveButton onClick={()=>{handleReleased(0,'rel')}}>Release Selected</OliveButton>
      </Box>

      {/* Action buttons grid */}
      <Box
        sx={{
          border: "1px solid #ccc",
          borderRadius: 1,
          mx: 2,
          mb: 2,
          overflow: "hidden",
        }}
      >
        <Grid container>
          <Grid item xs={2} sx={{ width: "16.66%" }}>
            <ActionButton icon={<Star />} label="Shopper Ratings" />
          </Grid>
          <Grid item xs={2} sx={{ width: "16.66%" }}>
            <ActionButton icon={<CardGiftcard />} label="Bonus" />
          </Grid>
          <Grid item xs={2} sx={{ width: "16.66%" }}>
            <ActionButton icon={<Warning />} label="Penalty" />
          </Grid>
          <Grid item xs={2} sx={{ width: "16.66%" }}>
            <ActionButton icon={<Refresh />} label="RollBack" />
          </Grid>
          <Grid item xs={2} sx={{ width: "16.66%" }}>
            <ActionButton icon={<CheckCircle />} label="Approve" />
          </Grid>
          <Grid item xs={2} sx={{ width: "16.66%" }}>
            <ActionButton icon={<Copyright />} label="Redcape Report" />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={2} sx={{ width: "16.66%" }}>
            <ActionButton icon={<Send />} label="Release" />
          </Grid>
          <Grid item xs={2} sx={{ width: "16.66%" }}>
            <ActionButton icon={<Info />} label="Update Shopper" />
          </Grid>
          <Grid item xs={2} sx={{ width: "16.66%" }}>
            <ActionButton icon={<Description />} label="PDF DOWNLOAD" />
          </Grid>
          <Grid item xs={2} sx={{ width: "16.66%" }}>
            <ActionButton icon={<Edit />} label="Edit Report" />
          </Grid>
          <Grid item xs={2} sx={{ width: "16.66%" }}>
            <ActionButton icon={<Chat />} label="Editor Summary" />
          </Grid>
        </Grid>
      </Box>

      {/* Delete Selected Reports button */}
      <Box sx={{ mb: 2, px: 2 }}>
        <OliveButton onClick={()=>{handleDelteReport()}}>Delete Selected Reports</OliveButton>
      </Box>

      {/* Reports Table */}
      <TableContainer
        component={Paper}
        sx={{ mx: 2, mb: 4, border: "1px solid #ccc" }}
      >
        <Table>
          <TableHead sx={{ bgcolor: "#7a7d52" }}>
            <TableRow>
              <TableCell padding="checkbox" sx={{ color: "white" }}>
                <Checkbox
                  indeterminate={
                    selectedRow.length > 0 && selectedRow.length < reportlist.length
                  }
                  checked={reportlist.length > 0 && selectedRow.length === reportlist.length}
                  onChange={(e) => {
                    if (e.target.checked) {
                      // Select all rows
                      setSelectedRow(reportlist.map((item) => item.reportHeaderId));
                    } else {
                      // Deselect all
                      setSelectedRow([]);
                    }
                  }}
                />

              </TableCell>
              <TableCell sx={{ color: "white" }}>(HH:MM:SS)</TableCell>
              <TableCell sx={{ color: "white" }}>Date entered</TableCell>
              <TableCell sx={{ color: "white" }}>Venue</TableCell>
              <TableCell sx={{ color: "white" }}>Month</TableCell>
              <TableCell sx={{ color: "white" }}>Entered by</TableCell>
              <TableCell sx={{ color: "white" }}>Approved by</TableCell>
              <TableCell sx={{ color: "white" }}>Score</TableCell>
              <TableCell sx={{ color: "white" }}>PDF</TableCell>
              <TableCell sx={{ color: "white" }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reportlist.length > 0 ? (

              reportlist.map((row, index) => {
                const date = new Date(
                  row.inspectionDateTime
                ).toLocaleDateString("en-GB");
                // const time = new Date(
                //   row.inspectionDateTime
                // ).toLocaleTimeString("en-GB");
                let timeDifference = "00:00:00";

                if (row.reportStatusCode !== "unc" && row.submitDate && row.reportCreatedDate) {
                  const submitDate: any = new Date(row.submitDate);
                  const reportCreatedDate: any = new Date(row.reportCreatedDate);

                  const diffMs = Math.abs(submitDate - reportCreatedDate);

                  const hours = Math.floor(diffMs / (1000 * 60 * 60));
                  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
                  const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

                  timeDifference = `${hours.toString().padStart(2, "0")}:${minutes
                    .toString()
                    .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
                }

                return (
                  <TableRow key={index}>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedRow.includes(row.reportHeaderId)}
                        onChange={() => { handleSelectRow(row.reportHeaderId) }}
                      />
                    </TableCell>
                    <TableCell>{timeDifference}</TableCell>
                    <TableCell>{date}</TableCell>
                    <TableCell>
                      <Typography
                        variant="body2"
                        color="primary"
                        sx={{ cursor: "pointer" }}
                      >
                        {row.venueName}
                      </Typography>
                    </TableCell>
                    <TableCell>{row.reportMonth}</TableCell>
                    <TableCell
                      style={{ cursor: "pointer", textDecoration: "underline" }}
                      onClick={(e) => {
                        //setLoanData(item);
                        handleHover(e, index, row);
                      }}
                    >
                      {row.userName}
                    </TableCell>
                    <TableCell>admin</TableCell>
                    <TableCell sx={{ bgcolor: "#e8f5e9" }}>
                      {row.finalScore}
                    </TableCell>
                    <TableCell
                      onClick={() => handleDownloadPdf(row.allocationId)}
                    >
                      <IconButton size="small">
                        <Description />
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", gap: 0.5 }}>
                        <Tooltip title="Copyright" arrow>
                          <span>
                            <IconButton size="small" className="iconColor">
                              <Copyright />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip title="Shopper Rating" arrow>
                          <span>
                            <IconButton
                              size="small"
                              className="iconColor"
                              onClick={() =>
                                handleOpenRatingDialog(row.reportHeaderId)
                              }
                            >
                              <Star />
                              <sub style={{ fontSize: "0.75rem" }}>
                                ({Math.round(row.starRatingScore)})
                              </sub>
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip title="Editor Summary" arrow>
                          <span>
                            <IconButton
                              size="small"
                              className="iconColor"
                              onClick={() => {
                                handleOpeneditorSummeryDialog(row.reportHeaderId);
                              }}
                            >
                              <Chat />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip title="Bonus" arrow>
                          <span>
                            <Badge
                              color="error"
                              variant="dot"
                              invisible={row.bonus === "0.00"}
                            >

                              <IconButton
                                size="small"
                                className="iconColor"
                                onClick={() => {
                                  handleOpenBonusDialog(row.reportHeaderId);
                                }}
                              >
                                <CardGiftcard />
                              </IconButton>
                            </Badge>
                          </span>
                        </Tooltip>
                        <Tooltip title="penalty" arrow>
                          <span>
                            <IconButton

                              size="small"
                              className="iconColor"
                              onClick={() => {
                                handleOpenPenaltyDialog(row.reportHeaderId);
                              }}
                            >
                              <Warning
                                sx={{
                                  color:
                                    row.penalty && row.penalty !== "0.00"
                                      ? "red"
                                      : "inherit",
                                }}
                              />
                            </IconButton>
                          </span>
                        </Tooltip>

                        <Tooltip title="Rollback" arrow>
                          <IconButton
                            size="small"
                            className="iconColor"
                            sx={{ transform: "scaleX(-1)" }}
                            onClick={() => {
                              handleRollBack(row.reportHeaderId, "unc");
                            }}
                          >
                            <Refresh />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Approve" arrow>
                          <IconButton
                            size="small"
                            className="iconColor"
                            onClick={() => {
                              handleApproved(row.reportHeaderId, "app");
                            }}
                          >
                            <CheckCircle />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Release" arrow>
                          <IconButton
                            size="small"
                            className="iconColor"
                            onClick={() => {
                              handleReleased(row.reportHeaderId, "rel");
                            }}
                          >
                            <Send />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Alert Shopper" arrow>
                          <IconButton size="small" className="iconColor">
                            <Info />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Edit Report" arrow>
                          <IconButton
                            size="small"
                            className="iconColor"
                            onClick={() => {
                              handleEditScoreCard(row.allocationId);
                            }}
                          >
                            <Edit />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={9}>
                  <Typography className="text-center fw-bold" variant="h5">
                    Data Not Found
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={datalength}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        {loanData ? (<Dcrage handleClose={handleClose} loanData={loanData} />) : null}
      </Popover>

      {/* Bonus Dialog */}
      <Dialog
        open={bonusDialogOpen}
        onClose={handleCloseBonusDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
          }}
        >
          <Typography variant="h6">Bonus</Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseBonusDialog}
            aria-label="close"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ mb: 3 }}>
            <Typography variant="body1" sx={{ mb: 1, fontWeight: "medium" }}>
              Amount:
            </Typography>
            <TextField
              fullWidth
              value={bonusAmount}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const value: any = e.target.value;
                if (parseFloat(value) >= 0 || value === "") {
                  setBonusAmount(value);
                }
              }}
              variant="outlined"
              type="number"
              inputProps={{ min: 0, step: 0.01 }}
            />
          </Box>
          <Box>
            <Typography variant="body1" sx={{ mb: 1, fontWeight: "medium" }}>
              Reason:
            </Typography>
            <TextField
              fullWidth
              value={bonusReason}
              onChange={(e: any) => setBonusReason(e.target.value)}
              variant="outlined"
              multiline
              rows={4}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", py: 2 }}>
          <OliveButton onClick={handleSaveBonus}>Save</OliveButton>
        </DialogActions>
      </Dialog>

      {/* Panelty Dialog */}
      <Dialog
        open={penaltyDialogOpen}
        onClose={handleClosePenaltyDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
          }}
        >
          <Typography variant="h6">Penalty</Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClosePenaltyDialog}
            aria-label="close"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ mb: 3 }}>
            <Typography variant="body1" sx={{ mb: 1, fontWeight: "medium" }}>
              Amount:
            </Typography>
            <TextField
              fullWidth
              value={penaltyAmount}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                const value: any = e.target.value;
                if (parseFloat(value) >= 0 || value === "") {
                  setPenaltyAmount(value);
                }
              }}
              variant="outlined"
              type="number"
              inputProps={{ min: 0, step: 0.01 }}
            />
          </Box>
          <Box>
            <Typography variant="body1" sx={{ mb: 1, fontWeight: "medium" }}>
              Reason:
            </Typography>
            <TextField
              fullWidth
              value={penaltyReason}
              onChange={(e: any) => setPenaltyReason(e.target.value)}
              variant="outlined"
              multiline
              rows={4}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", py: 2 }}>
          <OliveButton onClick={handleSavePenalty}>Save</OliveButton>
        </DialogActions>
      </Dialog>

      {/* Editor Summery Dialog */}
      <Dialog
        open={editorSummeryDialogOpen}
        onClose={handleCloseEditorSummeryDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
          }}
        >
          <Typography variant="h6">Editor Summary:</Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseEditorSummeryDialog}
            aria-label="close"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box>
            <TextField
              fullWidth
              value={editorSummery}
              onChange={(e: any) => setEditorSummery(e.target.value)}
              variant="outlined"
              multiline
              rows={4}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", py: 2 }}>
          <OliveButton onClick={handleSaveEditorSummery}>Save</OliveButton>
        </DialogActions>
      </Dialog>

      {/* Shopper Rating Dialog */}
      <Dialog
        open={ratingDialogOpen}
        onClose={handleCloseRatingDialog}
        maxWidth="md"
        fullWidth
        className="shopperRating"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
          }}
        >
          <Typography variant="h6">Shopper Rating</Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseRatingDialog}
            aria-label="close"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ mb: 3 }}>
            {/* Top row ratings */}
            <Grid container spacing={3}>
              {/* Overall Report */}
              {masterRating.length > 0 &&
                masterRating.map((items, index) => {
                  const currentRating =
                    ratings &&
                    ratings.find(
                      (rating) => rating.overRatingId === items.overAllRatingId
                    );
                  return (
                    <>
                      {index == 3 && (
                        <Divider
                          className="col-10 mx-auto"
                          sx={{ my: 3, borderColor: "grey" }}
                        />
                      )}
                      <Grid item xs={4} sx={{ width: "31.33%" }}>
                        <Box sx={{ textAlign: "center" }}>
                          <Typography variant="body1" sx={{ mb: 1 }}>
                            {items.overAllRatingId} {items.overAllRatingDesc}
                          </Typography>
                          <RatingEmoji
                            rating={currentRating?.overAllRatingScore}
                          />
                          <Box
                            sx={{ display: "flex", justifyContent: "center" }}
                          >
                            <Rating
                              name="overall-report"
                              value={currentRating?.overAllRatingScore}
                              onChange={(_, newValue) => {
                                if (newValue !== null) {
                                  handleRatingChange(
                                    items.overAllRatingId,
                                    newValue
                                  );
                                }
                              }}
                            />
                          </Box>
                        </Box>
                      </Grid>
                    </>
                  );
                })}
            </Grid>

            <Divider sx={{ my: 3 }} />

            {/* Comments Section */}
            <Box sx={{ mt: 4 }}>
              <Typography variant="body1" sx={{ mb: 1, fontWeight: "medium" }}>
                Comments:
              </Typography>

              {/* Rich Text Editor */}
              <PatchedReactQuill
                setEditorValue={setRatingComment}
                editorValue={ratingComment}
                isUpdate={false}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", py: 2 }}>
          <OliveButton onClick={handleSaveRating}>
            Save & Inform shopper
          </OliveButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
